// usePanelSettings.js
import { useState, useEffect } from '@wordpress/element';
import { VayuBlocksDevice } from '@vayu-blocks/device-control';

const advancePanelKeys = [
	'advance-layout',
	'advance-flex',
	'advance-background',
	'advance-border',
	'advance-hover',
	'advance-cursor',
	'advance-display',
	'advance-responsive'
];

export const usePanelSettings = ({ clientId, panelKeys, defaultTab = 'slide', initialPanels }) => {

	const deviceView = VayuBlocksDevice();

	// Merge user panelKeys + advancePanelKeys
	const allPanelKeys = [...panelKeys, ...advancePanelKeys];

	const [tab, setTab] = useState(() => {
		const savedTab = sessionStorage.getItem(`vb-panel-${clientId}-tab`);
		return savedTab || defaultTab;
	});

	const [lastOpenedPanels, setLastOpenedPanels] = useState(() => {
		const saved = sessionStorage.getItem(`vb-panel-${clientId}-last`);
		return saved ? JSON.parse(saved) : initialPanels;
	});

	const [openPanels, setOpenPanels] = useState(() => {
		const saved = sessionStorage.getItem(`vb-panel-${clientId}-openPanels`);
		if (saved) return JSON.parse(saved);
		const defaults = {};
		allPanelKeys.forEach(key => (defaults[key] = false));
		defaults[initialPanels[defaultTab]] = true;
		return defaults;
	});

	const setTabAndStore = (newTab) => {
		setTab(newTab);
		sessionStorage.setItem(`vb-panel-${clientId}-tab`, newTab);
	};

	const onTogglePanel = (panelKey) => {
		setOpenPanels(prev => {
			const newState = { ...prev, [panelKey]: !prev[panelKey] };

			if (newState[panelKey]) {
				const updated = { ...lastOpenedPanels, [tab]: panelKey };
				setLastOpenedPanels(updated);
				sessionStorage.setItem(`vb-panel-${clientId}-last`, JSON.stringify(updated));
			}

			sessionStorage.setItem(`vb-panel-${clientId}-openPanels`, JSON.stringify(newState));
			return newState;
		});
	};

	const openLastPanelForTab = () => {
		const panelKey = lastOpenedPanels[tab];
		if (panelKey) {
			const newState = {};
			allPanelKeys.forEach(key => (newState[key] = false));
			newState[panelKey] = true;
			setOpenPanels(newState);
		}
	};

	useEffect(() => {
		openLastPanelForTab();
	}, [tab]);

	useEffect(() => {
		openLastPanelForTab();
	}, [deviceView]);

	return {
		tab,
		setTab: setTabAndStore,
		openPanels,
		onTogglePanel,
	};
};
